import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';

import { Card, Spinner } from 'reactstrap';

import { Tabs } from 'ui-kit-takeat';

import { Container, LoadingContainer } from './styles';

import Category from './Category';

import { PageTitle } from '~/components/PageTitle';

import { useAuth } from '~/context/AuthContext';

import api from '~/services/api';

function N99FoodRelation() {
  const { user } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [categories, setCategories] = useState([]);
  const [complementCategories, setComplementCategories] = useState([]);

  const [n99FoodRestaurants, setN99FoodRestaurants] = useState([]);

  const getIfoodMenus = useCallback(async () => {
    try {
      const response = await api.get(`restaurants/99food/menu`);

      const restaurants = response.data.map((menu) => {
        return {
          name: menu.name,
          ifood_restaurant_id: menu.ifood_restaurant_id,
          merchant_id: menu.merchant_id,
        };
      });

      setN99FoodRestaurants(restaurants);

      toast.success('Produtos 99Food atualizados');
    } catch (err) {
      console.log('Get 99food products error: ', err.message);
      toast.error('Erro ao carregar produtos 99Food');
    }
  }, [user]);

  const getCategories = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.get('/restaurants/products', {
        params: {
          n99food: true,
        },
      });

      setCategories(response.data);
    } catch (err) {
      toast.error('Falha ao carregar dados');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const getComplementsCategories = useCallback(async () => {
    try {
      const response = await api.get(
        '/restaurants/product/complement-category',
        {
          params: {
            n99food: true,
          },
        }
      );

      setComplementCategories(response.data);
    } catch (err) {
      toast.error('Falha ao carregar dados');
    }
  }, []);

  useEffect(() => {
    getCategories();
    getComplementsCategories();
    getIfoodMenus();
  }, []);

  return isLoading ? (
    <LoadingContainer>
      <Spinner />
      <div>Carregando Cardápio...</div>
    </LoadingContainer>
  ) : (
    <Container>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '10px',
        }}
      >
        <PageTitle>Cardápio 99Food</PageTitle>
      </div>

      <Tabs
        containerStyles={{ zIndex: 1 }}
        tabs={['Produtos', 'Complementos']}
        onChangeTab={setActiveTab}
        selected={activeTab}
      />

      <Card
        style={{
          paddingBottom: '20px',
          boxShadow: '1px 0px 5px 1px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          borderTopLeftRadius: '0px',
          transition: 'border-radius 0.2s',
        }}
      >
        {activeTab === 0 &&
          categories.map((category, index) => (
            <Category
              key={category.id}
              category={category}
              n99FoodRestaurants={n99FoodRestaurants}
              type="product"
            />
          ))}

        {activeTab === 1 &&
          complementCategories.map((category, index) => (
            <Category
              key={category.id}
              category={category}
              n99FoodRestaurants={n99FoodRestaurants}
              type="complement"
            />
          ))}
      </Card>
    </Container>
  );
}

export default N99FoodRelation;
